import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import './style.scss';
import Button from 'components/Button/Button';
import InputText from 'components/InputText/InputText';
import { FormattedMessage, useIntl } from 'react-intl';
import I18nService from 'components/i18n/I18nService';

const ConfirmOtp = ({ isOpenModal, closeModal, confirmAction, sendOTP }) => {
  const [otp, setOtp] = useState('');
  const intl = useIntl();

  return (
    <Modal show={isOpenModal} onHide={closeModal} className="confirm-otp">
      <Modal.Header closeButton>
        <Modal.Title><FormattedMessage id='IDS_TV_XAC_NHAN' /></Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="mt-4">
          <InputText
            placeholder={intl.formatMessage({ id: 'IDS_TV_REQUEST_OTP' })}
            handleOnChange={(value) => setOtp(value)}
            value={otp}
            onEnter={() => confirmAction(otp)}
            onlyNumber
          />
        </div>
        <div className="display-center mt-4">
          <Button onClick={closeModal} buttonClass="close-btn">
            <FormattedMessage id='IDS_SHUYDV' />
          </Button>
          <Button disabled={!otp} buttonClass="mr-4" onClick={() => confirmAction(otp)}>
            <FormattedMessage id='IDS_TV_CONFIRM' />
          </Button>
        </div>

        <div className="text-resend">
          <div>{I18nService('IDS_SRESENDOTP', { intl, onClick: sendOTP })}</div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default React.memo(ConfirmOtp);